export function getUsageLimit(subscription) {
  if (!subscription) return 50;
  if (subscription.plan === "pro") return Infinity;
  if (subscription.stripe_status === "trialing") return 50;
  if (subscription.plan === "lite") return 50;
  return 200; // active starter
}
